export function getTextColorUtils(backgroundColor: string): string {
  const r = parseInt(backgroundColor.slice(1, 3), 16) * 0.299;
  const g = parseInt(backgroundColor.slice(3, 5), 16) * 0.587;
  const b = parseInt(backgroundColor.slice(5, 7), 16) * 0.114;

  const L = r + g + b;
  const textLight = L < 180;
  return textLight ? "#ffffff" : "#000000";
}
